/**
 * Waste measurement units with Norwegian names.
 *
 * Used by the B7 waste questions to let the user choose whether a waste type
 * is measured by mass (kg) or volume (m³).
 */

/** Unit codes mapped to Norwegian names. */
export const wasteUnitsNb: Record<string, string> = {
  kg: "Kilogram (kg)",
  m3: "Kubikkmeter (m³)",
}

/** Sorted array of { code, name } for use in dropdowns. */
export const wasteUnitsOptionsNb: Array<{ code: string; name: string }> = Object.entries(wasteUnitsNb)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name, "nb"))
